import { render, staticRenderFns } from "./AbkOfferTab.vue?vue&type=template&id=20e83500&scoped=true&"
import script from "./AbkOfferTab.vue?vue&type=script&lang=js&"
export * from "./AbkOfferTab.vue?vue&type=script&lang=js&"
import style0 from "./AbkOfferTab.vue?vue&type=style&index=0&id=20e83500&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e83500",
  null
  
)

export default component.exports